/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _DailyClosingSummaryState = {
  rsvn_sales: null,
  ota_comsn: null,
  rsvn_pay_comsn: 0,
  sales: 0,
  fixed_costs: 0,
  variable_costs: 0,
  variable_expenses: 0,
  fixed_expenses: 0,
  accom_tax: 0,
  accom_pay_comsn: 0
}

class DailyClosingSummaryState extends Record(_DailyClosingSummaryState) {
  mergeModel(model) {
    return this.merge(model)
  }
}

export { DailyClosingSummaryState }
